import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import config from "../../config/configs";
const BASE_URL = config.SERVER_BASE_URL;

interface CompanyState {
        company_info: any;
        myCompanyInfoFilled: any;
        myBillingInfoFilled: any;
        iframeState: any;
        companyinfoStatus: any;
        wordpress_connection_id: any;
        connectionVerificationStatus: 'idle' | 'verifying' | 'connected' | 'disconnected';
        shopify_shop: string | null;
        shopify_access_token: string | null;
}

const initialState: CompanyState = {
        company_info: {},
        myCompanyInfoFilled: {},
        myBillingInfoFilled: {},
        iframeState: false,
        companyinfoStatus: "idle",
        wordpress_connection_id: null,
        connectionVerificationStatus: 'idle',
        shopify_shop: null,
        shopify_access_token: null,
};

const getCookie = (name: string) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();
        return null;
};

export const updateCompanyInfo = createAsyncThunk(
        "company/update",
        async (postData: any, thunkAPI) => {

                let accountKey = {
                        "account_key": getCookie("AccountGUID") || "default-key",
                        // "business_info": {
                        //   "first_name": "Jamess",
                        //   "last_name": "Theopistos",
                        //   "company_name": "FINERWORKS",
                        //   "address_1": "15851 COLTON WL",
                        //   "address_2": "",
                        //   "address_3": null,
                        //   "city": "San Antonio",
                        //   "state_code": "TX",
                        //   "province": "",
                        //   "zip_postal_code": "78247",
                        //   "country_code": "us",
                        //   "phone": "2106027088",
                        //   "email": "james@gmail.com",
                        //   "address_order_po": "this is test"
                        // }
                };
                postData = { ...accountKey, ...postData }
                console.log('postData...', postData)
                const response = await fetch(BASE_URL + "update-company-information", {
                        method: "PUT",
                        headers: {
                                "Content-Type": "application/json",
                        },
                        body: JSON.stringify(postData)
                });
                const data = await response.json();
                console.log("company data", data)
                return data;
        },
);


export const Company = createSlice({
        name: "company",
        initialState,
        reducers: {
                updateCompany: (state, action: PayloadAction) => {
                        console.log('updateCompanyAction', state)
                        state.myCompanyInfoFilled = action.payload;
                },
                updateBilling: (state, action: PayloadAction<any>) => {
                        state.myBillingInfoFilled = action.payload;
                },
                updateIframeState: (state, action: PayloadAction) => {
                        state.iframeState = action.payload;
                },
                updateWordpressConnectionId: (state, action: PayloadAction<any>) => {
                        state.wordpress_connection_id = action.payload;
                },
                setConnectionVerificationStatus: (state, action: PayloadAction<'idle' | 'verifying' | 'connected' | 'disconnected'>) => {
                        state.connectionVerificationStatus = action.payload;
                },
                resetVerificationStatus: (state) => {
                        state.connectionVerificationStatus = 'idle';
                },
                updateShopifyCredentials: (state, action: PayloadAction<{ shop: string; access_token: string }>) => {
                        state.shopify_shop = action.payload.shop;
                        state.shopify_access_token = action.payload.access_token;
                }
        },
        extraReducers: (builder) => {
                builder.addCase(updateCompanyInfo.fulfilled, (state, action) => {
                        console.log("load ", action.payload)
                        const data = {
                                data: {
                                        ...action.payload.data,
                                },
                               
                        }
                        console.log("load ", data)
                        state.company_info = data;
                        state.companyinfoStatus = "success";
                });
        },
});

export const { 
        updateCompany, 
        updateBilling, 
        updateIframeState, 
        updateWordpressConnectionId,
        setConnectionVerificationStatus,
        resetVerificationStatus,
        updateShopifyCredentials
} = Company.actions;

